<template>
  <div>
    <SnackbarComponent
      v-model="snackbar.show"
      :message="snackbar.message"
      :color="snackbar.color"
    />
    <v-dialog v-model="dialog" max-width="520px" persistent>
      <v-card>
        <v-card-title class="text-h5 pa-4">Add Support Module</v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <v-form ref="form" v-model="valid">
            <v-text-field
              v-model="moduleName"
              label="Module Name"
              variant="outlined"
              density="compact"
              :rules="[
                (v) => !!String(v || '').trim() || 'Module name is required',
              ]"
            />
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="handleClose">Cancel</v-btn>
          <v-btn
            color="primary"
            variant="flat"
            :disabled="loading"
            :loading="loading"
            @click="handleSubmit"
          >
            Add Module
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { create_support_module_masters } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";

export default {
  name: "CreateModule",
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "created"],
  data() {
    return {
      valid: false,
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
      moduleName: "",
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    modelValue(newVal) {
      if (!newVal) {
        this.resetForm();
      }
    },
  },
  methods: {
    handleClose() {
      this.dialog = false;
      this.resetForm();
    },
    resetForm() {
      this.moduleName = "";
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    async handleSubmit() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        return;
      }

      this.loading = true;
      try {
        const response = await client.graphql({
          query: create_support_module_masters,
          variables: {
            input: {
              module_name: this.moduleName.trim(),
              module_status: "ACTIVE",
            },
          },
        });
        const rawPayload = response.data.create_support_module_masters;
        const responseData =
          typeof rawPayload === "string" ? JSON.parse(rawPayload) : rawPayload;
        if (responseData.success === true || responseData.status == "SUCCESS") {
          this.loading = false;
          this.snackbar = {
            show: true,
            message:
              responseData.status_message ||
              (typeof responseData.message === "string"
                ? responseData.message
                : "") ||
              "Support module added successfully",
            color: "success",
          };
          this.$emit("created");
          this.handleClose();
        } else {
          this.loading = false;
          this.snackbar = {
            show: true,
            message:
              responseData.status_message ||
              (typeof responseData.message === "string"
                ? responseData.message
                : "") ||
              "Failed to create module",
            color: "error",
          };
        }
      } catch (error) {
        this.loading = false;
        console.error("Error creating support module:", error);
        this.snackbar = {
          show: true,
          message:
            (typeof error?.message === "string" && error.message) ||
            "Failed to create module",
          color: "error",
        };
      }
    },
  },
};
</script>

<style scoped></style>
